import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'whatsapp'
})
export class WhatsappPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return `https://api.whatsapp.com/send?phone=972` + value.substr(1, value.length);
  }

}
